import { stringify as bem } from 'rebem-classname';

export default bem;
